const getISODateString = (date?: string | number | Date): string => {
  if (date) {
    return new Date(date).toISOString();
  }
  return new Date().toISOString();
};

export { getISODateString };
